/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';
import options, { saga as optionsSaga } from 'store/ducks/programInfo/bar/options';
import runOptions, { saga as runOptionsSaga } from 'store/ducks/programInfo/bar/runOptions';

export default combineReducers({
  options,
  runOptions,
});

export const sagas = [call(optionsSaga), call(runOptionsSaga)];
